import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal, message } from 'antd';
import PermissionButton from '../../permissions/PermissionButton';
import { getDevisById, getItemsInDevis } from '../../models/devisAPI';
import { DeliveryModeAPI } from '../../models/listsAPI';
import { buildVentileHtml, paginateVentileDocument } from './ventileTemplate';

export const loadVentileDocuments = async selectedDevis => {
  if (!selectedDevis.length) throw new Error('Sélectionnez au moins un devis.');
  const documents = [];
  // Bound concurrent requests when preparing large print selections.
  for (let start = 0; start < selectedDevis.length; start += 5) {
    const batch = await Promise.all(selectedDevis.slice(start, start + 5).map(async selected => {
      if (!selected.id) throw new Error('ID du devis manquant.');
      const [header, lines] = await Promise.all([getDevisById(selected.id), getItemsInDevis(selected.id)]);
      if (!header.data || !Array.isArray(lines.data)) throw new Error('Données du devis incomplètes.');
      return { devis: header.data, items: lines.data };
    }));
    documents.push(...batch);
  }
  return documents;
};

export const openVentileDevis = async (selectedDevis, preview = false) => {
  const hideLoading = message.loading('Préparation des ventilés A5 par étage…', 0);
  let frame;
  try {
    const [documents, modes] = await Promise.all([
      loadVentileDocuments(selectedDevis),
      DeliveryModeAPI.getAll({ headers: { 'X-Workflow-Module': 'quotes' } }),
    ]);
    const html = buildVentileHtml(documents, modes);
    frame = document.createElement('iframe');
    frame.title = 'Aperçu des devis ventilés A5';
    frame.style.cssText = 'position:fixed;left:-10000px;top:0;width:220mm;height:80vh;border:0;';
    const loaded = new Promise(resolve => { frame.onload = resolve; });
    frame.srcdoc = html;
    document.body.appendChild(frame);
    await loaded;
    await paginateVentileDocument(frame.contentDocument);
    const print = () => {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    };
    if (!preview) {
      frame.contentWindow.addEventListener('afterprint', () => frame.remove(), { once: true });
      print();
      return;
    }
    const host = document.createElement('div');
    document.body.appendChild(host);
    const paginatedHtml = `<!DOCTYPE html>${frame.contentDocument.documentElement.outerHTML}`;
    const close = () => {
      frame.remove();
      ReactDOM.unmountComponentAtNode(host);
      host.remove();
    };
    ReactDOM.render(
      <Modal title={`Ventilés / Par étage — ${documents.length} devis — A5 paysage`}
        open width="95%" style={{ maxWidth: 1000, top: 20 }} onCancel={close}
        footer={[
          <PermissionButton permissionModule="quotes" permissionAction="print" key="print" type="primary" onClick={print}>Imprimer</PermissionButton>,
          <Button key="close" onClick={close}>Fermer</Button>,
        ]}>
        <iframe title="Ventilés A5 par étage" srcDoc={paginatedHtml} style={{ width: '100%', height: '75vh', border: 0 }} />
      </Modal>, host
    );
  } catch (error) {
    frame?.remove();
    throw error;
  } finally {
    hideLoading();
  }
};
